import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';
import { BodyText } from '@kvdbil/components';
import { formatMoney } from '~/helpers/currency';
import FinanceMonthlyCost from '~/App/shared/components/FinanceCalculator/FinanceMonthlyCost';
import {
  MONTHLY_COST_MONTHS,
  MONTHLY_COST_RESIDUAL_VALUE_MONTHS
} from '~/config/constants';

const FinancingInformation = styled(BodyText)`
  color: ${({ theme }) => theme.colors.text.dark};
`;

const FinancingInformationContent = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 1rem;
  align-items: center;
`;

const FinanceMonthlyCostValue = styled.span`
  white-space: nowrap;
`;

interface Props {
  buyNowAmount: number;
  withResidualValue?: boolean;
}

const AlternativePaymentInformationBuyNow = ({
  buyNowAmount,
  withResidualValue
}: Props) => {
  const { t } = useTranslation();

  const loanCalculationAmountVariable = buyNowAmount;

  return (
    <FinancingInformation as="div">
      <FinancingInformationContent>
        <span>{t('Carloan from')}</span>

        <FinanceMonthlyCost
          months={
            withResidualValue
              ? MONTHLY_COST_RESIDUAL_VALUE_MONTHS
              : MONTHLY_COST_MONTHS
          }
          price={loanCalculationAmountVariable}
          withResidualValue={withResidualValue}
        >
          {({ value }) => (
            <FinanceMonthlyCostValue>
              {formatMoney({
                value,
                currency: t('SEK / month')
              })}
            </FinanceMonthlyCostValue>
          )}
        </FinanceMonthlyCost>
      </FinancingInformationContent>
    </FinancingInformation>
  );
};

export default AlternativePaymentInformationBuyNow;
